import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CampaignIcon from '@mui/icons-material/Campaign';

const AnnouncementToast = ({ announcement, onClose }) => {

  if (!announcement) return null;

  const marqueeText = `📢  ${announcement.title}  —  ${announcement.message}  `.repeat(3);

  return (
    <>
      <style>{`
        @keyframes slideInFromTop {
          from { transform: translateY(-100%); opacity: 0; }
          to   { transform: translateY(0);    opacity: 1; }
        }
        @keyframes marqueeScroll {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes pulse-glow {
          0%, 100% { box-shadow: 0 0 0 0 rgba(255, 200, 0, 0.6), 0 8px 40px rgba(0,0,0,0.4); }
          50%       { box-shadow: 0 0 0 10px rgba(255, 200, 0, 0), 0 8px 40px rgba(0,0,0,0.4); }
        }
      `}</style>

      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          animation: 'slideInFromTop 0.5s cubic-bezier(0.22, 1, 0.36, 1) forwards, pulse-glow 2s ease-in-out 0.5s infinite',
          background: 'linear-gradient(90deg, #7c3aed 0%, #db2777 50%, #ea580c 100%)',
          borderBottom: '3px solid rgba(255,220,0,0.8)',
          overflow: 'hidden',
        }}
      >
        {/* Top label bar */}
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          sx={{ px: 2, pt: 0.8, pb: 0.3 }}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <CampaignIcon sx={{ color: '#fde68a', fontSize: 20, animation: 'none' }} />
            <Typography
              sx={{
                color: '#fde68a',
                fontWeight: 800,
                fontSize: '0.72rem',
                letterSpacing: 3,
                textTransform: 'uppercase',
              }}
            >
              New Announcement
            </Typography>
          </Box>
          <IconButton
            size="small"
            onClick={onClose}
            sx={{
              color: 'rgba(255,255,255,0.8)',
              p: 0.3,
              '&:hover': { color: '#fff', bgcolor: 'rgba(255,255,255,0.15)', borderRadius: '50%' }
            }}
          >
            <CloseIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Box>

        {/* Marquee scrolling text */}
        <Box sx={{ overflow: 'hidden', pb: 0.8, px: 0 }}>
          <Box
            sx={{
              display: 'inline-flex',
              whiteSpace: 'nowrap',
              animation: 'marqueeScroll 40s linear infinite',
              willChange: 'transform',
            }}
          >
            <Typography
              component="span"
              sx={{
                color: '#ffffff',
                fontWeight: 700,
                fontSize: { xs: '0.88rem', md: '1rem' },
                letterSpacing: 0.5,
                px: 4,
                textShadow: '0 1px 6px rgba(0,0,0,0.3)',
              }}
            >
              {marqueeText}
            </Typography>
            {/* Duplicate for seamless loop */}
            <Typography
              component="span"
              sx={{
                color: '#ffffff',
                fontWeight: 700,
                fontSize: { xs: '0.88rem', md: '1rem' },
                letterSpacing: 0.5,
                px: 4,
                textShadow: '0 1px 6px rgba(0,0,0,0.3)',
              }}
            >
              {marqueeText}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default AnnouncementToast;
